import React from 'react';
import { HStack, Text } from '@chakra-ui/react';
import AddOfficerAssessmentButton from './AddOfficerAssessmentButton';
import { useTokens } from '../../../../context/TokenProvider';
import { localise } from '../../../../services/lang/lang';
const AddOfficerAssessmentPanel = ({ remoteSubmission, handleOfficerAssessmentCreated, canEdit, }) => {
    const tokens = useTokens();
    return (React.createElement(HStack, { "data-testid": "add_officer_assessment_panel", borderBottomRadius: tokens.BorderRadius02, padding: tokens.Spacing05, justifyContent: "space-between", bgColor: tokens.CanvasPrimary100 },
        React.createElement(Text, { variant: "dk-800-rg-3" }, localise('OFFICER_ASSESSMENT')),
        React.createElement(AddOfficerAssessmentButton, { isDisabled: !canEdit, remoteSubmission: remoteSubmission, onCreated: handleOfficerAssessmentCreated })));
};
export default AddOfficerAssessmentPanel;
